import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { EmpOffContactType, Office } from '../../data';

import { useSxStyles } from './useStyles';

type Props = {
  data: EmpOffContactType;
  companyOffice: Office[];
};

export const WorkContactReadMode = ({ data: emp, companyOffice }: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const officeLocation = companyOffice.find(
    (country) => country.fOfficeId === emp.fEmpOfficeLoc,
  );

  return (
    <div>
      <Box component="table" sx={sxStyles.table}>
        <tbody>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpPhoneWork')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + emp.fEmpPhoneWork}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpPhoneMob')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + emp.fEmpPhoneMob}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpEmailHome')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + emp.fEmpEmailWork}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpOfficeLoc')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' +
                (emp.fEmpOfficeLoc && officeLocation
                  ? officeLocation.fOfficeCity
                  : '')}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpOfficeFloor')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + emp.fEmpOfficeFloor}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpOfficeRoom')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + emp.fEmpOfficeRoom}
            </Box>
          </tr>
        </tbody>
      </Box>
    </div>
  );
};
